import { Box, Typography } from "@mui/material";
import PLModal from "components/patternLib/PLModal";
import React from "react";
import translations from "translations";

interface DeleteCommentModalProps {
  onCancelDelete: () => void;
  onConfirmDelete: () => void;
  show: boolean;
}

const DeleteCommentModal: React.FC<DeleteCommentModalProps> = ({ onCancelDelete, onConfirmDelete, show }) => {
  return (
    <PLModal
      allowCloseOnBackdrop
      modalTitle={translations.pages.assetManagement.assetDetails.deleteComment}
      lhCancel={onCancelDelete}
      lhConfirm={onConfirmDelete}
      lhClose={onCancelDelete}
      show={show}
      iconName="bin"
    >
      <>
        <Box slot="modal-content">
          <Typography variant="copy">{translations.pages.assetManagement.assetDetails.deleteCommentMessage}</Typography>
        </Box>
      </>
    </PLModal>
  );
};
export default DeleteCommentModal;
